export const getProceedToInvestmentProduct = (state) => state.investment.proceedToInvestmentProduct
